export default __webpack_public_path__ + "static/media/579.f7cecd7d.png";